export default __webpack_public_path__ + "static/media/logo.acdf9962.svg";